import { html } from 'lit';
const FileIconNone =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill="#fff" d="M2.4 2.4A2.4 2.4 0 0 1 4.8 0h9.6c.192 0 .377.076.512.212l6.476 6.476c.136.136.212.32.212.512v14.4a2.4 2.4 0 0 1-2.4 2.4H4.8a2.4 2.4 0 0 1-2.4-2.4z"/><path fill="#CDCDCD" fill-rule="evenodd" d="M4.8 23.1h14.4a1.5 1.5 0 0 0 1.5-1.5V7.273L14.327.9H4.8a1.5 1.5 0 0 0-1.5 1.5v19.2a1.5 1.5 0 0 0 1.5 1.5M4.8 0a2.4 2.4 0 0 0-2.4 2.4v19.2A2.4 2.4 0 0 0 4.8 24h14.4a2.4 2.4 0 0 0 2.4-2.4V7.2a.72.72 0 0 0-.212-.512L14.912.212A.72.72 0 0 0 14.4 0z" clip-rule="evenodd"/><path fill="#CDCDCD" fill-rule="evenodd" d="M13.95 4.8V.3h.9v4.5a1.95 1.95 0 0 0 1.95 1.95h4.5v.9h-4.5a2.85 2.85 0 0 1-2.85-2.85" clip-rule="evenodd"/>
  </svg>
`;
export default FileIconNone;
